import React, {
  FunctionComponent,
} from "react";
import { Drawer } from '@mui/material';
import {useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import './sideNavBar.style.css';
import { connect, useDispatch } from 'react-redux';
import {themeColors} from "../../Components/theme";
import './SideNav.css';
import SideNav from "./SideNav"; 
import Navbar from "../Navbar/Navbar";

type props = {
  props?: any;
  title:
  | "Organizations"
  | "Contacts"
  | "Users"
  | "Bookings"
  | "Drilldown"
  | "Team";
  path?: string;
  leadManger?: Boolean;
  operationManger?: Boolean;
  project?: string;
  task?: string;
  resources?: string;
  callLogs?: string;
  faq?: string;
  user: any;
  api?: string;
  news?: string;
  apiData?: string;
  leadDistributor?: string;
  customButton?: string;
  appTheme:any;
  updatePassword?: string;
  minimized?: boolean;
  drawerOpen?: boolean;
  onDrawerToggle?: () => void;
  isMobile?: boolean;
  onMenuItemClick?: () => void;
};
const MiniDrawer: FunctionComponent<props> = ({
  props,
  title,
  path,
  leadManger,
  operationManger,
  project,
  task,
  resources,
  callLogs,
  faq,
  user,
  api,
  news,
  apiData,
  leadDistributor,
  customButton,
  appTheme,
  updatePassword,
  minimized,
  drawerOpen,
  onDrawerToggle,
  isMobile,
  onMenuItemClick
}) => {
   const sideNavbarContainer = {
    backgroundColor: appTheme
      ? themeColors.sidebarBackgroundColor
      : themeColors.sidebarBackgroundColorDark,

    color: appTheme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const drawerWidth = minimized ? 240 : 60;

  /* ===========================================================
     ========== MOBILE SIDEBAR (TEMPORARY DRAWER) ==============
     =========================================================== */
  if (isMobile) {
    return (
      <Drawer
        anchor="left"
        open={!!drawerOpen}
        onClose={onDrawerToggle}
        variant="temporary"
        ModalProps={{ keepMounted: true }}
        sx={{
          "& .MuiDrawer-paper": {
            width: 220,
            backgroundColor: appTheme
              ? themeColors.sidebarBackgroundColor
              : themeColors.sidebarBackgroundColorDark,
            color: appTheme ? themeColors.textPrimary : themeColors.textPrimaryDark,
            position: "relative",
          },
        }}
      >
        {/* Close button */}
        <span
          style={{
            position: "absolute",
            top: 5,
            right: 10,
            zIndex: 2000,
            cursor: "pointer",
            fontSize: 15,
            color: appTheme ? "#fff" : themeColors.textPrimaryDark,
          }}
          onClick={onDrawerToggle}
          aria-label="Close sidebar"
        >
          &#10005;
        </span>

        {/* Actual Sidebar Content */}
        <SideNav
          user={user.profile}
          pathname={props?.history?.location?.pathname}
          sadmin={user.user_email}
          Tcolor={sideNavbarContainer}
          minimized={minimized}
          onMenuItemClick={onMenuItemClick}
        />
      </Drawer>
    );
  }

  /* ===========================================================
     ========== DESKTOP SIDEBAR (PERMANENT) =====================
     =========================================================== */
  return (
    <Box
      className="containerSideBar"
      sx={{
        display: "flex",
        minHeight: "100vh",
        overflow: "hidden",
        marginTop: 0,
      }}
    >
      {/* Sidebar */}
      <Box
        sx={{
          width: drawerWidth,
          position: "fixed",
          left: 0,
          top: 0,
          height: "100vh",
          zIndex: 1200,
          color: appTheme ? themeColors.textPrimary : themeColors.textPrimaryDark,
          transition: "width 0.2s",
        }}
      >
        <SideNav
          user={user.profile}
          pathname={props?.history?.location?.pathname}
          sadmin={user.user_email}
          Tcolor={sideNavbarContainer}
          minimized={minimized}
        />
      </Box>

      {/* Content Area */}
      <Box
        sx={{
          flex: 1,
          marginLeft: `${drawerWidth + (minimized ? 15 : 5)}px`,
          width: "100%",
          transition: "margin-left 0.2s",
        }}
      >
        <Navbar
          props={props}
          title={"Users"}
          path={"/"}
          leadManger={false}
          api={"/apis"}
          news={"/news"}
          customButton={"/customButton"}
          leadDistributor={"/leadDistributor"}
          project={"/projects"}
          faq={"/faq"}
          resources={"/resources"}
          apiData={"/apiData"}
          open={minimized}
        />
      </Box>
    </Box>
  );
};

/* ================================
   MAP REDUX STATE TO PROPS
================================ */
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    appTheme: state.theme.isLightMode,
    minimized: state.drawerToggle.drawerOpen,
  };
};

export default connect(mapStateToProps)(MiniDrawer);
